// extracted by mini-css-extract-plugin
export default {"modalTitle":"styles_modalTitle__skHNo","title":"styles_title__VLQDn","modalButtons":"styles_modalButtons__8o4GR","closeButton":"styles_closeButton__xo2Il"};